import { tKeys, useTranslation } from 'locales';
import type { Automation } from 'modules/Settings/Automation/api/use-load-automation';
import { prop } from 'remeda';

import { useLoadAutomations } from '../../../api';

import { useAutomationWizardFormContext } from './automation-wizard-form';

export function useAutomationSettingsController() {
  const { t } = useTranslation();
  const form = useAutomationWizardFormContext();

  const automation = form.getValues();

  const { automations } = useLoadAutomations();

  const handleSetTrigger = (trigger: Automation['triggers'][number]) => {
    const maybeIndex = automation.triggers.indexOf(trigger);
    if (maybeIndex !== -1) form.removeListItem('triggers', maybeIndex);
    else form.insertListItem('triggers', trigger);
  };

  const getNameFieldProps = () => {
    const existingNames = automations
      .filter(({ id }) => id !== form.getValues().id)
      .map(prop('name'));
    const currentName = form.getValues().name;

    if (existingNames.includes(currentName))
      return { error: t(tKeys.AUTOMATION.WIZARD.STEP1.NAME_TAKEN) };

    return {};
  };

  return {
    getNameFieldProps,
    handleSetTrigger,
  };
}
